var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"drag-box",style:({height:_vm.startHeight+'px'||'',top:_vm.top+'px',opacity: _vm.opacity,'background-color':_vm.background})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }